import Section from './TopColorsSection'
import isEmpty from './TopColorsIsEmpty'

export default { Section, isEmpty }
